import { useRef, useState, useImperativeHandle, forwardRef } from "react";
import Card from "../cards/card/Card.jsx";
// const [selected, setSelected] = React.useState(false);

const CardList = forwardRef(({ cards, selectedIds,onSelectChange,showPhone=false}, ref) => {
//   const [selectedIds, setSelectedIds] = useState(new Set());

//  const handleSelectChange = (id, checked) => {
//     setSelectedIds(prev => {
//       const newSet = new Set(prev);
//       if (checked) {
//         newSet.add(id);
//       } else {
//         newSet.delete(id);
//       }
//       return newSet;
//     });
//   };


 // Public method or you can hook this to a button click
  const getSelectedIds = () => {
    return Array.from(selectedIds);
  };

  // Example: you can log or expose getSelectedIds on a button click
  const handleShowSelected = () => {
    alert("Selected IDs: " + getSelectedIds().join(", "));
  };


//   // Expose a public method
//   useImperativeHandle(ref, () => ({
//     getSelectedCardIds: () => selectedIds,
//   }));

  
  return (
    
    <div className="cardList">
      {cards?.map(item => (
            <Card
            key={item.id}
            item={item}
            selected={selectedIds.has(item.id)}
            onSelectChange={(id, checked) => {
                console.log("CardList onSelectChange:", id, checked);
                onSelectChange(id, checked);
            }}
            showPhone={showPhone}
            />
      ))}





    </div>


  );
});

export default CardList;
